<template>
    <div class="w-100 h-100">
        <b-modal
            v-model="showModal"
            hide-header
            hide-header-close
            title="Data Submitted"
            centered
            @ok="clearFields"
        >
            <div class="text-center">
                <div>{{ModalMessage}}</div>
            </div>
        </b-modal>
      <b-container fluid>
        <h2 class="tw-mb-0 text-aegis-dk">iELISA Processing</h2>
        <p class="tw-italic tw-text-gray-700">
          Blood sample processing
        </p>
      </b-container>
      <br />
  
      <!-- Show this row when page first loads -->
      <b-row v-if="blood_sample_id == ''">
        <b-col cols="3"></b-col>
        <b-col cols="4">
            <b-form-input
                v-model="aliquot_id"
                placeholder="Scan Aliquot Barcode"
                @keypress.enter="getIElisa"
            ></b-form-input>
        </b-col>
        <b-col cols="2">
            <b-button
                @click="getIElisa()"
                :disabled="aliquot_id == ''"
            >Submit</b-button>
        </b-col>
        <b-col cols="3"></b-col>
      </b-row>
      <!-- Show this after we know which Blood Sample Analysis object we need -->
      <b-row v-else>
        <b-col cols="3"></b-col>
        <b-col cols="6">
            <b-row>
                <b-col><h1 class="tw-text-2xl tw-font-bolder text-center tw-mb-0">iELISA Processing for Blood Sample ID: {{ blood_sample_id }}</h1></b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col>
                    <b-form-group
                        id="Dengue V1 OD Value"
                        label="Dengue V1 OD Value"
                    >
                        <b-form-input
                            v-model="ielisa_dengue_v1_od_value"
                            placeholder="Dengue V1 OD Value"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col>
                    <b-form-group
                        id="Dengue V2 OD Value"
                        label="Dengue V2 OD Value"
                    >
                        <b-form-input
                            v-model="ielisa_dengue_v2_od_value"
                            placeholder="Dengue V2 OD Value"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col>
                    <b-form-group
                        id="Dengue V3 OD Value"
                        label="Dengue V3 OD Value"
                    >
                        <b-form-input
                            v-model="ielisa_dengue_v3_od_value"
                            placeholder="Dengue V3 OD Value"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col>
                    <b-form-group
                        id="Dengue V4 OD Value"
                        label="Dengue V4 OD Value"
                    >
                        <b-form-input
                            v-model="ielisa_dengue_v4_od_value"
                            placeholder="Dengue V4 OD Value"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-button
                class="mt-2"
                variant="success"
                size="lg"
                block
                @click="getIElisa('update')"
                :disabled="processing_submit_disabled"
            >Submit Data</b-button>
        </b-col>
        <b-col cols="3"></b-col>
      </b-row>
    </div>
  </template>
  
<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
  import * as _ from "lodash";
  
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
  
export default {
mixins: [
    DashboardBaseTemplate,
],
components: {},
props: {},
data: function() {
    return {
            showModal: false,
            ModalMessage: '',
            blood_sample_id: '',
            blood_sample_analysis_id: '',
            aliquot_id: '',
            ielisa_dengue_v1_od_value: '',
            ielisa_dengue_v2_od_value: '',
            ielisa_dengue_v3_od_value: '',
            ielisa_dengue_v4_od_value: ''
    };
},
computed: {
    processing_submit_disabled:function () {
        let disabled = false;
        let testing_fields = [
            this.ielisa_dengue_v1_od_value,
            this.ielisa_dengue_v2_od_value,
            this.ielisa_dengue_v3_od_value,
            this.ielisa_dengue_v4_od_value
        ]
        _.each(testing_fields, function(field) {
            if (field == null || field == '') {
                disabled = true;
            }
          });
        return disabled;
    }
},
watch: {},
created: function() {},
mounted: function() {},
methods: {
    getIElisa: function(mode = null) {
        const that = this;
        const fd = new FormData();
        fd.append("aliquot_id", that.aliquot_id);
        
        if (mode == "update") {
            fd.append("mode", mode);
            fd.append("ielisa_dengue_v1_od_value", that.ielisa_dengue_v1_od_value);
            fd.append("ielisa_dengue_v2_od_value", that.ielisa_dengue_v2_od_value);
            fd.append("ielisa_dengue_v3_od_value", that.ielisa_dengue_v3_od_value);
            fd.append("ielisa_dengue_v4_od_value", that.ielisa_dengue_v4_od_value);
        }
        HTTP.post('srilanka/blood_sample/ielisa_processing/', fd).then((response) => {
            that.blood_sample_id = response.data.blood_sample_id;
            that.blood_sample_analysis_id = response.data.blood_sample_analysis_id;
            that.ielisa_dengue_v1_od_value = response.data.ielisa_dengue_v1_od_value;
            that.ielisa_dengue_v2_od_value = response.data.ielisa_dengue_v2_od_value;
            that.ielisa_dengue_v3_od_value = response.data.ielisa_dengue_v3_od_value;
            that.ielisa_dengue_v4_od_value = response.data.ielisa_dengue_v4_od_value;
            if (mode == 'update') {
                this.ModalMessage = 'Submitted successfully';
                this.showModal = true;
            }
        }).catch((error) => {
            this.ModalMessage = 'There was a problem. Please check input values and try again.';
            this.showModal = true;
            HandleErrors.HandleErrors(error);
        });
    },
    clearFields() {
        this.blood_sample_id = '';
        this.blood_sample_analysis_id = '';
        this.aliquot_id = '';
        this.ielisa_dengue_v1_od_value = '';
        this.ielisa_dengue_v2_od_value = '';
        this.ielisa_dengue_v3_od_value = '';
        this.ielisa_dengue_v4_od_value = '';
    }
}
};
</script>

<style scoped></style>
  